import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Avatar as AntAvatar } from 'antd';
import avatarIcon from 'assets/images/avatar-icon.svg';

import s from './avatar.pcss';


export default class Avatar extends Component {
  static propTypes = {
    defaultIcon: PropTypes.string,
    size: PropTypes.number,
    link: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    defaultIcon: avatarIcon,
    size: 40,
    link: null,
    onClick: () => false,
  };

  state = {
    link: this.props.link,
  };

  onError = () =>
    this.setState({ link: null });

  render() {
    const { link } = this.state;
    return (
      <div onClick={this.props.onClick}>
        {link &&
          <AntAvatar icon="user" className={s.avatar} size={this.props.size} onError={this.onError} src={link} />
        }
        {!link &&
          <AntAvatar icon="user" className={s.avatar} size={this.props.size} onError={this.onError} src={this.props.defaultIcon} />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Avatar/index.js